import React from "react";
import {useErrorBoundary} from "react-error-boundary";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LoginBackGroundImage from "../assets/login_background_image.webp";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import {CPSErrorBoundaryFallbackStyle} from "./CPSErrorBoundaryFallbackStyle";
import Button from "@mui/material/Button";
import {CPSMessages} from "commonUtils/enumerations";
import {logMessage} from "services/loggerService";
import {store} from "../redux/store";

const CPSErrorBoundaryFallback: React.FC<any> = ({error}) => {
  const {resetBoundary} = useErrorBoundary();

  const handleRedirect = () => {
    window.location.href = "/";
  };

  return (
    <Box
      style={{
        backgroundImage: `url(${LoginBackGroundImage})`,
        backgroundSize: "cover",
      }}
      sx={CPSErrorBoundaryFallbackStyle.boxBackgroudStyle}>
      <Box sx={CPSErrorBoundaryFallbackStyle.errorHandlerBoxStyle}>
        <Grid container spacing={1}>
          <Grid item xs={1}>
            <ErrorOutlineIcon
              sx={CPSErrorBoundaryFallbackStyle.errorOutlineIconStyle}
            />
          </Grid>
          <Grid item xs={8}>
            <Box>{CPSMessages.EXCEPTION_HANDLER_TITLE}</Box>
            <Box sx={CPSErrorBoundaryFallbackStyle.workWrapErrorTextStyle}>
              {error.message}
            </Box>
            <Button className="main-font-family" onClick={resetBoundary}>
              Try again
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Box sx={CPSErrorBoundaryFallbackStyle.clickHereStyle}>
              <Link onClick={handleRedirect} href="#">
                {" "}
                Click Here
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export const CPSlogError = (error: Error, info: React.ErrorInfo) => {
  try {
    const stateauth = store.getState();
    logMessage(
      "ERROR",
      `{ 
        "userId":"${stateauth?.auth?.userDetails?.userId}",
        "userIdentity":"${stateauth?.auth?.userDetails?.userIdentity}",
        "error" : "${error.message}" , 
        "errorInfo" : "${info.componentStack}"
      }`,
      window.location.pathname,
    );
  } catch (error: any) {
    logMessage(
      "CATCH EXCEPTION IN CPS LOG ERROR",
      `{ 
        "error" : "${error.message}"
      }`,
      window.location.pathname,
    );
  }
};

export default CPSErrorBoundaryFallback;
